import {
  createApiActions,
  createApiActionsWithoutSuccess,
} from '@app/shared/store/standard.actions';
import { PlcMixDesign } from '@cco/model';
import { props } from '@ngrx/store';

export const {
  baseAction: getIotGatewayThingDocument,
  failureAction: getIotGatewayThingDocumentFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_IOT_GATEWAY_THING_DOCUMENT',
  props<{ requestId?: string; assetUuid: string }>(),
);

export const {
  baseAction: getPlcGatewayThingDocument,
  failureAction: getPlcGatewayThingDocumentFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_PLC_GATEWAY_THING_DOCUMENT',
  props<{ requestId?: string; assetUuid: string }>(),
);

export const {
  baseAction: getPlcGatewayThingShadow,
  failureAction: getPlcGatewayThingShadowFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_PLC_GATEWAY_THING_SHADOW',
  props<{ requestId?: string; assetUuid: string }>(),
);

export const {
  baseAction: getPlcConfigThingDocument,
  failureAction: getPlcConfigThingDocumentFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_PLC_CONFIG_THING_DOCUMENT',
  props<{ requestId?: string; assetUuid: string }>(),
);

export const {
  baseAction: getPlcConfigThingShadow,
  failureAction: getPlcConfigThingShadowFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_PLC_CONFIG_THING_SHADOW',
  props<{ requestId?: string; assetUuid: string }>(),
);

export const {
  baseAction: getPlcCalibrationThingDocument,
  failureAction: getPlcCalibrationThingDocumentFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_PLC_CALIBRATION_THING_DOCUMENT',
  props<{ requestId?: string; assetUuid: string }>(),
);

export const {
  baseAction: getPlcCalibrationThingShadow,
  failureAction: getPlcCalibrationThingShadowFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_PLC_CALIBRATION_THING_SHADOW',
  props<{ requestId?: string; assetUuid: string }>(),
);

export const {
  baseAction: getPlcMixDesignThingDocument,
  failureAction: getPlcMixDesignThingDocumentFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_PLC_MIX_DESIGN_THING_DOCUMENT',
  props<{ requestId?: string; assetUuid: string; mixDesignSlot: string }>(),
);

export const {
  baseAction: getPlcMixDesignThingShadow,
  failureAction: getPlcMixDesignThingShadowFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_PLC_MIX_DESIGN_THING_SHADOW',
  props<{ requestId?: string; assetUuid: string; mixDesignSlot: string }>(),
);

export const {
  baseAction: updateMixDesign,
  successAction: updateMixDesignSuccess,
  failureAction: updateMixDesignFailure,
} = createApiActions(
  '[Mixer PLC] UPDATE_MIX_DESIGN',
  props<{
    requestId?: string;
    assetUuid: string;
    mixDesignSlot: string;
    plcMixDesign: PlcMixDesign;
  }>(),
  props<{ requestId?: string; assetUuid: string; mixDesignSlot: string; update: string }>(),
);

export const {
  baseAction: getPlcMixDesignThingDocuments,
  failureAction: getPlcMixDesignThingDocumentsFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_PLC_MIX_DESIGN_THING_DOCUMENTS',
  props<{ requestId?: string; assetUuid: string }>(),
);

export const {
  baseAction: getPlcMixDesignThingShadows,
  failureAction: getPlcMixDesignThingShadowsFailure,
} = createApiActionsWithoutSuccess(
  '[Mixer PLC] GET_PLC_MIX_DESIGN_THING_SHADOWS',
  props<{ requestId?: string; assetUuid: string }>(),
);
